import React, { Component } from "react";
import {
  Grid,
  Box,
  Button,
  TableContainer,
  FormControl,
  Menu,
  Paper,
  MenuItem,
  TextField,
  Typography,
  Slide,
  Tooltip,
  Collapse,
  IconButton,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import {
  Edit,
  Delete,
  RefreshOutlined,
  CallMissedOutgoing,
  ArrowForwardIos,
  ArrowBackIos,
  ViewList,
  Save,
  Print,
  InsertDriveFile,
  AddBox,
} from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchSales,
  fetchItemMaster,
  fetchDetailMaster,
  fetchCustomerMaster,
  apiURL,
  fetchReferenceMaster,
  fetchFarmerBillDetail,
  fetchItemDetail,
  fetchComagentDetail,
  apiFarmerURL,
} from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import SalesItemEntry from "./SalesItemEntry";
import SalesInvoiceSelection from "./SalesInvoiceSelection";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  copyRowsAllCols,
  getRowData,
  isNumeric,
  getTaxNumFromStr,
  getRowColSum,
  roundOff,
  convertEnglishToGujaratiNumber,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CustomerMaster from "./CustomerMaster";
import ReferenceMaster from "./ReferenceMaster";
import DetailMaster from "./DetailMaster";
import PaymentModeTable from "./PaymentModeTable";
import OrderSelection from "./OrderSelection";
import SalesEWayBill from "./SalesEWayBill";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import moment from "moment";
import ReceiptEntry from "./ReceiptEntry";
import EditableTable from "./CustomTool/EditableTable";
import InvoiceListTable from "./InvoiceListTable";
import FarmerBillItemEntry from "./FarmerBillItemEntry";
import FarmerMaster from "./FarmerMaster";
import FarmerBillList from "./FarmerBillList";
import ItemMaster from "./ItemMaster";
import ItemMaster2 from "./ItemMaster2";
import CommisionAgentMaster from "./CommisionAgentMaster";
import PaymentModeIcon from "../images/Payment Mode icon.jpg";
import { cleanDigitSectionValue } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils";

class FarmerBillEntry extends Component {
  state = {
    Company: [],
    Item: [],
    Village: [],
    Comagent: [],
    Farmer: [],
    inputRow: [],

    showList: false,
    expanded: true,
    printMenuAnchor: null,
    columns: [
      {
        id: "Action",
        label: "   ",
        name: "Search",
        type: "CtTxtNum",
        CtrlProps: {
          width: 5,
        },
      },

      {
        id: "bint_itemsrno",
        label: "નં.",
        hide: true,
        // type: "CtTxt",
        // CtrlProps: {
        //   width: 20,
        //   maxLength: 10,
        // },
      },
      {
        id: "bint_edititemsrno",
        label: "નં.",
        hide: true,
      },
      {
        id: "int_jansicode",
        label: "જણસી કોડ.",
        type: "CtTxtNum",
        CtrlProps: {
          width: 100,
          maxLength: 10,
          items: [],
          colID: "int_jansicode",
        },
      },
      {
        id: "vac_jansiname",
        label: "જણસી નામ",
        type: "CtCmbEditable",
        CtrlProps: {
          focus: false,
          width: 200,
          maxLength: 100,
          items: [],
          colID: "vac_jansiname",
        },
      },
      {
        id: "int_comagentcode",
        label: "લેનાર વેપારી કોડ ",
        type: "CtTxtNum",
        CtrlProps: {
          width: 100,
          maxLength: 100,
          items: [],
          colID: "int_comagentcode",
        },
      },
      {
        id: "vac_comagentname",
        label: "લેનાર વેપારી નામ",
        type: "CtCmbEditable",
        CtrlProps: {
          focus: false,
          width: 400,
          maxLength: 100,
          items: [],
          colID: "vac_comagentname",
        },
      },
      {
        id: "dec_theli",
        label: "થેલી",
        type: "CtTxtAmt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
        },
      },

      {
        id: "dec_rate",
        label: "ભાવ",
        type: "CtTxtAmt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
        },
      },
      {
        id: "dec_wt",
        label: "વજન",
        type: "CtTxtAmt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
        },
      },
      {
        id: "dec_uchak",
        label: "ઉચ્ચક",
        type: "CtTxtAmt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
        },
      },
      {
        id: "dec_amt",
        label: "કિંમત",
        type: "CtTxt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
          disabled: true,
        },
      },
      {
        id: "dec_marketfeesrate",
        label: "માર્કેટ ફી",
        type: "CtTxt",
        hide: true,
        CtrlProps: {
          width: 50,
          maxLength: 10,
          disabled: true,
        },
      },
      {
        id: "dec_marketfees",
        label: "માર્કેટ ફી",
        type: "CtTxt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
          disabled: true,
        },
      },
      {
        id: "dec_commisionrate",
        label: " કમિશન",
        type: "CtTxt",
        hide: true,
        CtrlProps: {
          width: 50,
          maxLength: 10,
          disabled: true,
        },
      },
      {
        id: "dec_commision",
        label: " કમિશન",
        type: "CtTxt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
          disabled: true,
        },
      },
      {
        id: "dec_totalamt", //txtTotalAmountItem
        label: "કુલ રકમ", //કુલ રકમ
        type: "CtTxt",
        CtrlProps: {
          width: 50,
          maxLength: 10,
          disabled: true,
        },
      },
      {
        id: "vac_remark",
        label: "રીમાર્ક",
        type: "CtMultiLineText",
        CtrlProps: {
          width: 100,
          maxLength: 1000,
        },
      },
    ],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "FarmerBillEntry:",
        actionType: "AlertResponsive",
        visiblecondition: [
          { colID: "DisableEdit", value: false, relationalOperator: "==" },
        ],
        // hide: (this.props.userPrivilege.Sales == 'R' || this.props.userPrivilege.Sales == 'W')
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "FarmerBillEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Sales == "R" ||
          this.props.userPrivilege.Sales == "W",
      },
    ],
    keyColumn: [
      "bint_no", //0
      "vac_date", //1
      "vac_farmername", //2
      "vac_fathername", //3
      "vac_city", //4
      "vac_itemtotal", //5
      "vac_truckrent", //6
      "dec_bardan", //7
      "dec_sutli", //8
      "dec_upad", //9
      "vac_amount", //10
      "dec_transaction", //11
      "dec_payment", //12
      "vac_remark1", //13
      "vac_paymentmode", //14
      "dec_farmerbillitemlist", //15
    ],

    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      // "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],

    formData: {
      transactionType: "બાકી",
      txtNo: 0,
      edit_farmerno: 0,
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbCustomer: "",
      txtItemTotal: "",
      bint_itemsrno: "",
      bint_inwardno: "",
      txtTruckRent: "",
      txtBardan: "",
      txtSutli: "",
      txtTotalAmount: "",
      txtAnay: "",
      txtUmero: "",
      txtBardan1: "",
      txtBaad: "",
      txttruckBhaddu: "",
      txtBardan: "",
      txtSutli: "",
      txtUpad: "",
      txtAnnay: "",
      txtBaadRakam: "",
      txtTotalRakaam: "",
      txtvepariNo: "",
      txtCity: "",
      txtkhedutNo: "",
      txtRemark: "",
      txtFarmerName: "",
      cmbFatherName: "",
      dec_rate: "",
      dec_theli: "",
      dec_wt: "",
      dec_uchak: "",
      dec_amt: "",
      dec_marketfees: "",
      dec_commision: "",
      dec_totalamt: "",
      bint_editinwordno: 0,
    },
    autoResetFormData: false,
    searchData: {
      bint_no: "",
      vac_date: "",
      vac_farmername: "",
      vac_hsncode: "",
      vac_city: "",
      vac_itemtotal: "",
      vac_truckrent: "",
      dec_bardan: "",
      dec_sutli: "",
      dec_upad: "",
      vac_amount: "",
      dec_transaction: "",
      vac_remark: "",
      dec_farmerbillitemlist: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    dataLoadStatus: true,
    ARD: null,
    DRP: "",
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    totalBeforeTaxAmt: 0,
    totalAfterTaxAmt: 0,

    columnsOtherDetail: [
      { id: "Action", label: "" },
      { id: "vac_headingvalue", label: "Headings" },
      { id: "txtFormate", label: "" },
      {
        id: "vac_value",
        label: "Values",
        type: "CtTxt",
        CtrlProps: {
          value: "",
          width: 150,
          maxLength: 20,
          amountOnlyCondition: [
            {
              colID: "vac_calculation",
              value: "-",
              relationalOperator: "===",
              logicalOperator: "||",
            },
            {
              colID: "vac_calculation",
              value: "+",
              relationalOperator: "===",
              logicalOperator: "||",
            },
          ],
        },
      },
    ],
    rowsOtherDetail: [],
    rowsOtherDetail1: [],

    rowsCountOtherDetail: 0,
    rowsCountOtherDetail1: 0,

    rowsPerPageOtherDetail: 10,
    rowsPerPageOtherDetail1: 10,

    Displaybtn: false,

    columnsPaymentMode: [
      // { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_ledgername", label: "Payment Mode Ledger" },
      {
        id: "dec_amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_chequeno",
        label: "Cheque No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "vac_referenceno",
        label: "Reference No",
        type: "CtTxtNum",
        CtrlProps: { value: "", width: 100, maxLength: 20 },
      },
      {
        id: "dat_transactiondate",
        label: "Transaction Date",
        type: "CtDtp",
        CtrlProps: { value: "", maxLength: 20 },
      },
      {
        id: "vac_remark",
        label: "Remark",
        type: "CtMultiLineText",
        CtrlProps: { value: "", width: 120, maxLength: 100 },
      },
      // { id: "vac_groupname", label: "Group Name", hide: true },
    ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    DefaultEntrySettingList: [],
    PaymentData: [],
    isEditMode: false, // Tracks edit mode
    isInitialLoad: true, // Tracks first load
    hasOpenedTransactionType: false,
    PaymentmodeListCols: [
      // "bint_acid",
      // "bint_ledgercode",
      // "bint_ledgeridsrno",
      // "dec_opbalance",
      // "vac_backgroundprocess",
      // "vac_company",
      // "vac_firmname",
      // "vac_groupheader",
      // "vac_groupname",
      // "vac_gstno",
      // "vac_ledgername",
    ],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : ખેડૂત બિલ એન્ટ્રી";
    this.props.setActiveMenu("FarmerBillEntry");
    // this.setSearchColumns();
    this.ShortCut();
    this.setJansiDetail();
    this.setComagentDetail();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.calculateTotalAmount();
    this.handleOnNewEntryClick(); // Add default rows on load
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
    window.removeEventListener("scroll", this.handleScroll);
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: () => {
          this.saveFarmerBill(false, false, false);
        },
        handleOnclickNew: this.clearInfo,
        handleOnclickPrint: () => {
          this.saveFarmerBill(false, false, true);
        },
        handleOnclickDelete: this.DeleteData,
        handleOnclickList: () => {
          this.props.navigateTo("FarmerBillList");
        },
        handleOnclickBaad: () => {
          document.getElementById("txttruckBhaddu").focus();
        },
        handleOnclickUmero: () => {
          document.getElementById("txtBardan1").focus();
        },
        handleOnclickJansiMaster: () => {
          this.onAddClickItem();
        },
        handleOnclickComMaster: () => {
          this.onAddClickComAgent();
        },
      }),
    });
  };
  calculateFarmerBaad = () => {
    const { txtBaad, txttruckBhaddu, txtBardan, txtSutli, txtUpad, txtAnay } =
      this.state.formData;

    const txtBaadRakam = (
      (parseFloat(txtBaad) || 0) +
      (parseFloat(txttruckBhaddu) || 0) +
      (parseFloat(txtBardan) || 0) +
      (parseFloat(txtSutli) || 0) +
      (parseFloat(txtUpad) || 0) +
      (parseFloat(txtAnay) || 0)
    ).toFixed(2);

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        txtBaadRakam,
      },
    }));
  };

  // calculateBothTotalAmount = () => {
  //   const { txtBaad, txttruckBhaddu, txtBardan, txtSutli, txtUpad, txtAnnay, txtUmero, txtBardan1, txtAnay } = this.state.formData;

  //   // Summing dec_amt from all rows
  //   const totalDecAmt = this.state.rows.reduce(
  //     (total, row) => total + (parseFloat(row.dec_amt) || 0), 0
  //   ).toFixed(2);
  //   // Convert values to numbers and provide default value (0) if invalid
  //   const txtTotalRakaam = (
  //     (parseFloat(txtBaad) || 0) -
  //     (parseFloat(txttruckBhaddu) || 0) -
  //     (parseFloat(txtBardan) || 0) -
  //     (parseFloat(txtSutli) || 0) -
  //     (parseFloat(txtUpad) || 0) -
  //     (parseFloat(txtAnnay) || 0) -
  //     (parseFloat(txtUmero) || 0) +
  //     (parseFloat(txtBardan1) || 0) +
  //     (parseFloat(txtAnay) || 0) +
  //     (parseFloat(totalDecAmt) || 0)  // Add total dec_amt to the calculation
  //   ).toFixed(2);

  //   this.setState((prevState) => ({
  //     formData: {
  //       ...prevState.formData,
  //       txtTotalRakaam,
  //     },
  //   }));
  // };

  calculateBothTotalAmount = () => {
    const {
      txtBaad,
      txttruckBhaddu,
      txtBardan,
      txtSutli,
      txtUpad,
      txtAnay,
      txtUmero,
      txtBardan1,
      txtAnnay,
    } = this.state.formData;

    // Summing dec_amt from all rows
    const totalDecAmt = this.state.rows.reduce(
      (total, row) => total + (parseFloat(row.dec_totalamt) || 0),
      0
    );
    // ).toFixed(2);
    // Convert values to numbers and provide default value (0) if invalid
    const txtTotalRakaam = (
      (parseFloat(txtBaad) || 0) -
      (parseFloat(txttruckBhaddu) || 0) -
      (parseFloat(txtBardan) || 0) -
      (parseFloat(txtSutli) || 0) -
      (parseFloat(txtUpad) || 0) -
      (parseFloat(txtAnay) || 0) -
      (parseFloat(txtUmero) || 0) +
      (parseFloat(txtBardan1) || 0) +
      (parseFloat(txtAnnay) || 0) +
      totalDecAmt
    ).toFixed(2);

    this.setState(
      (prevState) => {
        const targetLedgerNames = prevState.DefaultEntrySettingList.map(
          (row) => row.vac_ledgername
        ).filter(Boolean);

        const updatedRowsPaymentMode = prevState.rowsPaymentMode.map((row) => {
          if (targetLedgerNames.includes(row.vac_ledgername)) {
            return {
              ...row,
              dec_amount: parseFloat(txtTotalRakaam),
              chk_paymentmode: true,
            };
          }
          return row;
        });

        return {
          formData: {
            ...prevState.formData,
            txtTotalRakaam,
          },
          rowsPaymentMode: updatedRowsPaymentMode,
        };
      },
      () => {
        console.log("Updated payment modes:", this.state.rowsPaymentMode);
      }
    );
  };
  // calculateFarmerBoth = () => {
  //   const { txtBaadRakam, txtTotalAmount } = this.state.formData;
  //   const FarmerBoth = ((parseFloat(txtBaadRakam) || 0) + (parseFloat(txtTotalAmount) || 0)).toFixed(2);
  //   this.setState((prevState) => ({
  //     formData: {
  //       ...prevState.formData,
  //       txtTotalRakaam: FarmerBoth,
  //     },
  //   }));
  // };
  calculateFarmerItem = () => {
    const { dec_theli, dec_rate, dec_wt } = this.state.columns;

    // Convert values to numbers before addition
    const farmeritemcalculate = (
      (parseFloat(dec_theli) || 0) +
      (parseFloat(dec_rate) || 0) +
      (parseFloat(dec_wt) || 0)
    ).toFixed(2);

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        dec_amt: farmeritemcalculate,
      },
    }));
  };

  calculateFarmerUmmero = () => {
    const { txtUmero, txtBardan1, txtAnnay } = this.state.formData;

    // Convert values to numbers before addition
    const txtTotalAmount = (
      (parseFloat(txtUmero) || 0) +
      (parseFloat(txtBardan1) || 0) +
      (parseFloat(txtAnnay) || 0)
    ).toFixed(2);
    // console.log("Updated txtTotalAmount : 631", txtTotalAmount);

    this.setState(
      (prevState) => ({
        formData: {
          ...prevState.formData,
          txtTotalAmount,
        },
      }),
      () => {
        // Optional: Ensure the state update has finished and the value is reflected
        // console.log("Updated txtTotalAmount : 642", txtTotalAmount);
      }
    );
  };

  setJansiDetail = () => {
    // console.log("this.state.Item", this.state.Item)
    if (this.state.Item.length > 0) {
      this.state.Item.map((row) => {
        if (row.int_jansicode) {
          let columns = this.state.columns;
          columns = columns.map((col) => {
            if (col.id === "vac_jansiname") {
              col.CtrlProps.items = row.vac_jansiname;
            }
          });
        }
      });
    }
  };

  setComagentDetail = () => {
    if (this.state.Comagent.length > 0) {
      this.state.Comagent.map((row) => {
        if (row.int_comagentcode) {
          let columns = this.state.columns;
          columns = columns.map((col) => {
            if (col.id === "vac_comagentname") {
              col.CtrlProps.items = row.vac_comagentname;
            }
          });
        }
      });
    }
  };

  handleOnChange = (e) => {
    // const gujaratiValue = this.convertEnglishToGujaratiNumber(e.target.value);
    // console.log("gujaratiValue", gujaratiValue);
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "transactionType") {
          if (
            this.state.formData.transactionType === "ચૂકવેલ" &&
            !this.state.isInitialLoad &&
            !this.state.hasOpenedTransactionType
          ) {
            this.handleSelectTransactionType();
          }
          // Reset initial load after first change
          if (this.state.isInitialLoad) {
            this.setState({ isInitialLoad: false });
          }
        } else if (this.state.formData.transactionType === "બાકી") {
          this.setState({ hasOpenedTransactionType: false });
        }
        if (this.state.formData.txtItemTotal > 0) {
          // this.setState({ rowsPaymentMode: this.state.rowsPaymentMode });
        }
        if (
          e.target.name === "txtUmero" ||
          e.target.name === "txtBardan1" ||
          e.target.name === "txtAnnay"
        ) {
          this.calculateFarmerUmmero();
        }

        if (
          e.target.name === "txtBaad" ||
          e.target.name === "txttruckBhaddu" ||
          e.target.name === "txtBardan" ||
          e.target.name === "txtSutli" ||
          e.target.name === "txtUpad" ||
          e.target.name === "txtAnay"
        ) {
          this.calculateFarmerBaad();
        }
        if (
          e.target.name === "txtBaad" ||
          e.target.name === "txttruckBhaddu" ||
          e.target.name === "txtBardan" ||
          e.target.name === "txtSutli" ||
          e.target.name === "txtUpad" ||
          e.target.name === "txtAnay" ||
          e.target.name === "txtUmero" ||
          e.target.name === "txtBardan1" ||
          e.target.name === "txtAnnay"
        ) {
          this.calculateBothTotalAmount();
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnNewEntryClick = () => {
    this.setState(
      (prevState) => {
        let newRows = [...prevState.rows];

        let maxSrNo =
          newRows.length > 0
            ? Math.max(
                ...newRows.map((row) => Number(row.bint_edititemsrno) || 0)
              )
            : 0;

        let newSrNo = maxSrNo === 0 ? 1 : maxSrNo + 1;

        // let newRow = {
        //   bint_edititemsrno: newSrNo,
        //   bint_itemsrno: "",
        //   int_jansicode: "",
        //   vac_jansiname: "",
        //   int_comagentcode: "",
        //   vac_comagentname: "",
        //   dec_theli: "",
        //   dec_rate: "",
        //   dec_wt: "",
        //   dec_uchak: "",
        //   dec_amt: "",
        //   vac_remark: "",
        // };
        // newRows.push(newRow); // Update the newRows array

        let newBlankRows = [];

        // Create 5 rows, each with a unique `newSrNo` incremented by 1
        for (let i = 0; i < 5; i++) {
          let row = {
            bint_edititemsrno: newSrNo + i, // Increment `newSrNo` by `i` on each iteration
            bint_itemsrno: "",
            int_jansicode: "",
            vac_jansiname: "",
            int_comagentcode: "",
            vac_comagentname: "",
            dec_theli: "",
            dec_rate: "",
            dec_wt: "",
            dec_uchak: "",
            dec_amt: "",
            dec_marketfees: "",
            dec_commision: "",
            dec_totalamt: "",
            vac_remark: "",
          };

          newBlankRows.push(row); // Add the row to the array
        }

        // Add the new blank rows to the newRows array
        newRows.push(...newBlankRows);

        return {
          rows: newRows,
          rowsCount: newRows.length, // Fix: Use newRows.length instead of rows.length
        };
      },
      () => {
        document.getElementById("dtpDate").focus();
      }
    );
  };

  //   this.setState((prevState) => ({
  //   rows: [...prevState.rows, ...newEntries],
  // }));

  handleChangeRowsPerPageOtherDetail1 = (rowsPerPageOtherDetail1) => {
    this.setState({ rowsPerPageOtherDetail1 });
  };

  handleChangeRowsPerPagePaymentMode = (rowsPerPagePaymentMode) => {
    this.setState({ rowsPerPagePaymentMode });
  };

  handleScroll = () => {
    if (window.scrollY > 200 && this.state.expanded) {
      this.setState({ expanded: false });
    } else if (window.scrollY < 200) {
      this.setState({ expanded: true });
    }
  };

  // handleOnRowDataChange = (rows, handledRowIndex, colID) => {
  //   console.log("handledRowIndex", handledRowIndex);
  //   console.log("colID", colID);
  //   console.log("rows", rows);
  //   console.log("this.state.Item", this.state.Item);
  //   if (colID === "int_jansicode") {
  //     console.log("cur jansi code ", rows[handledRowIndex][colID]);
  //     let itemData = getRowData(
  //       this.state.Item,
  //       "int_jansicode",
  //       rows[handledRowIndex][colID]
  //     );
  //     console.log("itemData", itemData);
  //     rows[handledRowIndex]["vac_jansiname"] = itemData.vac_jansiname;
  //   } else if (colID === "vac_jansiname") {
  //   }
  //   this.setState({ rows });
  //   if (colID === "vac_jansiname") {
  //     console.log("cur jansi name ", rows[handledRowIndex][colID]);
  //     let itemData = getRowData(
  //       this.state.Item,
  //       "vac_jansiname",
  //       rows[handledRowIndex][colID]
  //     );
  //     console.log("itemData", itemData);
  //     rows[handledRowIndex]["int_jansicode"] = itemData.int_jansicode;
  //   } else if (colID === "int_jansicode") {
  //   }
  //   this.setState({ rows });
  //   if (colID === "int_comagentcode") {
  //     console.log("cur comagent code ", rows[handledRowIndex][colID]);
  //     let itemData = getRowData(
  //       this.state.Comagent,
  //       "int_comagentcode",
  //       rows[handledRowIndex][colID]
  //     );
  //     console.log("itemData", itemData);
  //     rows[handledRowIndex]["vac_comagentname"] = itemData.vac_comagentname;
  //   } else if (colID === "vac_comagentname") {
  //   }
  //   this.setState({ rows });
  //   if (colID === "vac_comagentname") {
  //     console.log("cur comagent name ", rows[handledRowIndex][colID]);
  //     let itemData = getRowData(
  //       this.state.Comagent,
  //       "vac_comagentname",
  //       rows[handledRowIndex][colID]
  //     );
  //     console.log("itemData", itemData);
  //     rows[handledRowIndex]["int_comagentcode"] = itemData.int_comagentcode;
  //   } else if (colID === "int_comagentcode") {
  //   }
  //   this.setState({ rows });
  // };

  // handleOnRowDataChange = (rows, handledRowIndex, colID) => {
  //   let updatedRows = [...rows];
  //   const currentRow = updatedRows[handledRowIndex];

  //   // Handle changes based on column ID
  //   if (colID === "int_jansicode") {
  //     // console.log("cur jansi code ", currentRow[colID]);
  //     let itemData = getRowData(this.state.Item, "int_jansicode", currentRow[colID]);
  //     // console.log("itemData", itemData);
  //     if (itemData) {
  //       currentRow["vac_jansiname"] = itemData.vac_jansiname;
  //       currentRow["dec_commision"] = itemData.dec_commision;
  //       currentRow["dec_marketfees"] = itemData.dec_marketfees;
  //     }
  //   } else if (colID === "vac_jansiname") {
  //     // console.log("cur jansi name ", currentRow[colID]);
  //     let itemData = getRowData(this.state.Item, "vac_jansiname", currentRow[colID]);
  //     // console.log("itemData", itemData);
  //     if (itemData) {
  //       currentRow["int_jansicode"] = itemData.int_jansicode;
  //       currentRow["dec_commision"] = itemData.dec_commision;
  //       currentRow["dec_marketfees"] = itemData.dec_marketfees;
  //     }
  //   } else if (colID === "int_comagentcode") {
  //     // console.log("cur comagent code ", currentRow[colID]);
  //     let itemData = getRowData(this.state.Comagent, "int_comagentcode", currentRow[colID]);
  //     // console.log("itemData", itemData);
  //     if (itemData) {
  //       currentRow["vac_comagentname"] = itemData.vac_comagentname;
  //     }
  //   } else if (colID === "vac_comagentname") {
  //     // console.log("cur comagent name ", currentRow[colID]);
  //     let itemData = getRowData(this.state.Comagent, "vac_comagentname", currentRow[colID]);
  //     // console.log("itemData", itemData);
  //     if (itemData) {
  //       currentRow["int_comagentcode"] = itemData.int_comagentcode;
  //       // console.log("currentRow", currentRow);
  //     }
  //   }

  //   if (colID === "dec_wt" || colID === "dec_rate") {
  //     console.log("currentRow", currentRow)
  //     const dec_wt = Number(currentRow.dec_wt) || 0;
  //     const dec_rate = Number(currentRow.dec_rate) || 0;
  //     const dec_marketfees = Number(currentRow.dec_marketfees) || 0;
  //     const dec_commision = Number(currentRow.dec_commision) || 0;

  //     const roundOff = (value, decimals) => {
  //       return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
  //     }

  //     console.log("dec_wt", dec_wt)
  //     console.log("dec_rate", dec_rate)
  //     console.log("dec_marketfees", dec_marketfees)
  //     console.log("dec_commision", dec_commision)

  //     // Check for valid values of dec_wt and dec_rate
  //     if (Number(dec_wt) > 0 && Number(dec_rate) > 0) {
  //       currentRow.dec_uchak = 0;
  //       currentRow.dec_amt = (Number(dec_rate) * Number(dec_wt)) / 20;

  //       console.log("currentRow.dec_amt", Number(currentRow.dec_amt));
  //       console.log("Number(dec_marketfees)", Number(dec_marketfees));
  //       console.log("(Number(dec_marketfees) / 100)", (Number(dec_marketfees) / 100));
  //       console.log("roundOff((Number(dec_marketfees) / 100), 4)", roundOff((Number(dec_marketfees) / 100), 4));

  //       currentRow.dec_marketfees =
  //         roundOff((roundOff((Number(dec_marketfees) / 100), 4) * Number(currentRow.dec_amt)), 0);

  //       console.log("roundOff", roundOff((0.007* 5), 0))

  //       // currentRow.dec_commision = roundOff((dec_commision / 100) * currentRow.dec_amt, 4);
  //       currentRow.dec_commision = (Number(currentRow.dec_amt) * roundOff((Number(dec_commision) / 100), 4), 0);

  //       // Calculate market fees and commission
  //       // currentRow.dec_marketfees = roundOff((dec_marketfees / 100) * currentRow.dec_amt, 4);
  //       // currentRow.dec_commision = roundOff((dec_commision / 100) * currentRow.dec_amt, 4);

  //       // Calculate total amount
  //       currentRow.dec_totalamt = roundOff(currentRow.dec_amt + currentRow.dec_marketfees + currentRow.dec_commision, 4);

  //       console.log('currentRow.dec_marketfees', currentRow.dec_marketfees)
  //       console.log('currentRow.dec_commision', currentRow.dec_commision)
  //       console.log('currentRow.dec_totalamt', currentRow.dec_totalamt)

  //     } else {
  //       const dec_uchak = parseFloat(currentRow.dec_uchak) || 0;
  //       const dec_theli = parseFloat(currentRow.dec_theli) || 0;

  //       console.log("currentrow 965", currentRow);
  //       console.log("966");

  //       // Check for valid values of dec_uchak and dec_theli
  //       if (dec_uchak > 0 && dec_theli > 0) {
  //         console.log("969");
  //         currentRow.dec_wt = 0;
  //         currentRow.dec_amt = dec_theli * dec_uchak;

  //         // Calculate market fees and commission
  //         currentRow.dec_marketfees = roundOff(
  //           roundOff((dec_marketfees / 100), 4) * currentRow.dec_amt, 0);

  //         // currentRow.dec_commision = roundOff((roundOff(dec_commision / 100), 4) * currentRow.dec_amt, 0);
  //         currentRow.dec_commision = roundOff(currentRow.dec_amt * roundOff((dec_commision / 100), 4), 0);

  //         // Calculate total amount
  //         currentRow.dec_totalamt = roundOff(currentRow.dec_amt + currentRow.dec_marketfees + currentRow.dec_commision, 4);
  //       }
  //     }
  //   } else if (colID === "dec_uchak" || colID === "dec_theli") {
  //     const dec_uchak = parseFloat(currentRow.dec_uchak) || 0;
  //     const dec_theli = parseFloat(currentRow.dec_theli) || 0;
  //     const dec_marketfees = Number(currentRow.dec_marketfees) || 0;
  //     const dec_commision = Number(currentRow.dec_commision) || 0;

  //     // Check for valid values of dec_uchak and dec_theli
  //     if (dec_uchak > 0 && dec_theli > 0) {
  //       currentRow.dec_wt = 0;
  //       currentRow.dec_amt = dec_theli * dec_uchak;

  //       // Calculate market fees and commission
  //       // currentRow.dec_marketfees = roundOff((dec_marketfees / 100) * currentRow.dec_amt, 4);
  //       // currentRow.dec_commision = roundOff((dec_commision / 100) * currentRow.dec_amt, 4);
  //       currentRow.dec_marketfees = roundOff(
  //         roundOff((dec_marketfees / 100), 4) * currentRow.dec_amt, 0);

  //       // currentRow.dec_commision = roundOff((roundOff(dec_commision / 100), 4) * currentRow.dec_amt, 0);
  //       currentRow.dec_commision = roundOff(currentRow.dec_amt * roundOff((dec_commision / 100), 4), 0);

  //       // Calculate total amount
  //       currentRow.dec_totalamt = roundOff(currentRow.dec_amt + currentRow.dec_marketfees + currentRow.dec_commision, 4);
  //     } else {
  //       const dec_wt = parseFloat(currentRow.dec_wt) || 0;
  //       const dec_rate = parseFloat(currentRow.dec_rate) || 0;

  //       // Check for valid values of dec_wt and dec_rate
  //       if (dec_wt > 0 && dec_rate > 0) {
  //         currentRow.dec_uchak = 0;
  //         currentRow.dec_amt = (dec_rate * dec_wt) / 20;

  //         // Calculate market fees and commission
  //         // currentRow.dec_marketfees = roundOff((dec_marketfees / 100) * currentRow.dec_amt, 4);
  //         // currentRow.dec_commision = roundOff((dec_commision / 100) * currentRow.dec_amt, 4);
  //         currentRow.dec_marketfees = roundOff(
  //           roundOff((dec_marketfees / 100), 4) * currentRow.dec_amt, 0);

  //         // currentRow.dec_commision = roundOff((roundOff(dec_commision / 100), 4) * currentRow.dec_amt, 0);
  //         currentRow.dec_commision = roundOff(currentRow.dec_amt * roundOff((dec_commision / 100), 4), 0);

  //         // Calculate total amount
  //         currentRow.dec_totalamt = roundOff(currentRow.dec_amt + currentRow.dec_marketfees + currentRow.dec_commision, 4);
  //       }
  //     }
  //   }

  //   console.log("updatedRows", updatedRows);

  //   this.setState({ rows: updatedRows }, () => {
  //     this.calculateBothTotalAmount(); // Call to recalculate txtTotalRakaam with the updated dec_amt
  //   });
  // };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    console.log("rows", rows);

    let updatedRows = [...rows];
    const currentRow = updatedRows[handledRowIndex];

    if (!currentRow.focus) {
      currentRow.focus = {
        vac_jansiname: false,
        vac_comagentname: false,
        dec_theli: false,
        dec_rate: false,
        dec_wt: false,
        dec_uchak: false,
      };
    }

    currentRow.focus[colID] =
      currentRow[colID] !== "" && currentRow[colID] !== 0;

    if (colID === "int_jansicode") {
      let itemData = getRowData(
        this.state.Item,
        "int_jansicode",
        currentRow[colID]
      );
      if (itemData) {
        currentRow["vac_jansiname"] = itemData.vac_jansiname;
        currentRow["dec_commision"] = itemData.dec_commision;
        currentRow["dec_marketfees"] = itemData.dec_marketfees;
        currentRow.focus.vac_jansiname = true;
      } else {
        currentRow["vac_jansiname"] = "";
        currentRow["dec_commision"] = 0;
        currentRow["dec_marketfees"] = 0;
        currentRow.focus.vac_jansiname = false;
      }
    } else if (colID === "vac_jansiname") {
      let itemData = getRowData(
        this.state.Item,
        "vac_jansiname",
        currentRow[colID]
      );
      if (itemData) {
        currentRow["int_jansicode"] = itemData.int_jansicode;
        currentRow["dec_commision"] = itemData.dec_commision;
        currentRow["dec_marketfees"] = itemData.dec_marketfees;
        currentRow.focus.vac_jansiname = true;
      } else {
        const jansiCodeExists = this.state.Item.some(
          (row) => row.int_jansicode === currentRow["int_jansicode"]
        );

        currentRow.focus.vac_jansiname = false;
        if (jansiCodeExists) {
          currentRow["int_jansicode"] = "";
        }
        currentRow["dec_commision"] = 0;
        currentRow["dec_marketfees"] = 0;
      }
    } else if (colID === "int_comagentcode") {
      let itemData = getRowData(
        this.state.Comagent,
        "int_comagentcode",
        currentRow[colID]
      );
      if (itemData) {
        currentRow["vac_comagentname"] = itemData.vac_comagentname;
        currentRow.focus.vac_comagentname = true;
      } else {
        currentRow["vac_comagentname"] = "";
        currentRow.focus.vac_comagentname = false;
      }
    } else if (colID === "vac_comagentname") {
      let itemData = getRowData(
        this.state.Comagent,
        "vac_comagentname",
        currentRow[colID]
      );
      if (itemData) {
        currentRow["int_comagentcode"] = itemData.int_comagentcode;
        currentRow.focus.vac_comagentname = true;
      } else {
        const comagentCodeExists = this.state.Comagent.some(
          (row) => row.int_comagentcode === currentRow["int_comagentcode"]
        );
        if (comagentCodeExists) {
          currentRow["int_comagentcode"] = "";
        }
        currentRow.focus.vac_comagentname = false;
      }
    }

    if (
      colID === "dec_wt" ||
      colID === "dec_rate" ||
      colID === "vac_jansiname" ||
      colID === "int_jansicode" ||
      colID === "dec_theli" ||
      colID === "dec_uchak"
    ) {
      let dec_wt = currentRow.dec_wt || 0;
      let dec_rate = currentRow.dec_rate || 0;

      let itemData = getRowData(
        this.state.Item,
        "int_jansicode",
        currentRow["int_jansicode"]
      );
      if (itemData != "") {
        currentRow["dec_commisionrate"] = itemData.dec_commision;
        currentRow["dec_marketfeesrate"] = itemData.dec_marketfees;
      } else {
        currentRow["dec_commisionrate"] = 0;
        currentRow["dec_marketfeesrate"] = 0;
      }
      let dec_marketfeesrate = Number(currentRow.dec_marketfeesrate) || 0;
      let dec_commisionrate = Number(currentRow.dec_commisionrate) || 0;
      let dec_uchak = currentRow.dec_uchak || 0;
      let dec_theli = currentRow.dec_theli || 0;

      // Update focus for weight/rate fields
      currentRow.focus.dec_wt = dec_wt > 0;
      currentRow.focus.dec_rate = dec_rate > 0;
      currentRow.focus.dec_theli = dec_theli > 0;
      currentRow.focus.dec_uchak = dec_uchak > 0;

      if (
        (colID == "dec_wt" && dec_wt > 0) ||
        (colID == "dec_rate" && dec_rate > 0)
      ) {
        dec_uchak = 0;
        currentRow.dec_amt = (dec_rate * dec_wt) / 20;
        currentRow.focus.dec_uchak = false;
        currentRow.focus.dec_theli = false;
      } else if (
        (colID == "dec_uchak" && dec_uchak > 0) ||
        (colID == "dec_theli" && dec_theli > 0)
      ) {
        dec_wt = 0;
        currentRow.dec_amt = dec_theli * dec_uchak;
        currentRow.focus.dec_wt = false;
        currentRow.focus.dec_rate = false;
      }

      currentRow.dec_wt = dec_wt;
      currentRow.dec_uchak = dec_uchak;

      if (!(dec_wt > 0 && dec_rate > 0) && !(dec_uchak > 0 && dec_theli > 0)) {
        currentRow.dec_amt = 0;
        currentRow.dec_commisionrate = 0;
        currentRow.dec_marketfeesrate = 0;
        currentRow.dec_totalamt = 0;
      }
      currentRow.dec_marketfees = roundOff(
        (dec_marketfeesrate / 100) * currentRow.dec_amt,
        0
      );
      currentRow.dec_commision = roundOff(
        (dec_commisionrate / 100) * currentRow.dec_amt,
        0
      );
      currentRow.dec_totalamt = roundOff(
        currentRow.dec_amt +
          currentRow.dec_marketfees +
          currentRow.dec_commision,
        0
      );
    }

    this.setState({ rows: updatedRows }, () => {
      this.calculateBothTotalAmount();
    });
  };

  handlePrintMenuOpen = (event) => {
    this.setState({ printMenuAnchor: event.currentTarget });
  };

  handlePrintMenuClose = () => {
    this.setState({ printMenuAnchor: null });
  };

  handleARDonActionClick = (row) => {
    // console.log("call");

    // console.log("row", row);

    let bint_itemsrno = row.bint_itemsrno,
      bint_edititemsrno = row.bint_edititemsrno,
      vac_jansiname = row.vac_jansiname,
      vac_comagentname = row.vac_comagentname,
      actionName = row.actionName;

    if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        // if (bint_itemsrno > 0) {
        //   let ARD = (
        //     <AlertResponsiveDialog
        //       labelAgree="Delete"
        //       labelDisagree="Cancel"
        //       alertTitle={"શું આપ જણસી : " + vac_jansiname + " લેનાર વેપારી:" + vac_comagentname + ", ને રદ કરવા માંગો છો?"}
        //       alertMessage=""
        //       handleOnClickYes={() => {
        //         return this.deletefarmerbillItem(
        //           bint_itemsrno
        //         );
        //       }}
        //       defaultOpenDialog={true}
        //       onYesClickCloseIfExeSuccessfully={true}
        //     />
        //   );
        //   this.setState({ ARD });
        // } else {
        //   let ARD = (
        //     <AlertResponsiveDialog
        //       labelAgree="Delete"
        //       labelDisagree="Cancel"
        //       alertTitle={"Do you want to Delete Item ?"}
        //       alertMessage=""
        //       handleOnClickYes={() => {
        //         return this.deletefarmerbillItemFE(bint_edititemsrno);
        //       }}
        //       defaultOpenDialog={true}
        //       onYesClickCloseIfExeSuccessfully={true}
        //     />
        //   )
        //   this.setState({ ARD });

        // }
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "શું આપ જણસી નામ :" +
              vac_jansiname +
              " અને લેનાર વેપારી નામ :" +
              vac_comagentname +
              " ને રદ કરવા માંગો છો?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              if (bint_itemsrno > 0) {
                return this.deletefarmerbillItem(bint_itemsrno);
              } else {
                return this.deletefarmerbillItemFE(bint_edititemsrno);
              }
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };
  deletefarmerbillItemFE = (bint_edititemsrno) => {
    let rows = this.state.rows.filter((row, index) => {
        if (row.bint_edititemsrno != bint_edititemsrno) {
          return row;
        }
      }),
      rowsCount = rows.length;
    this.setState({
      ARD: null,
      rows,
      rowsCount,
    });
  };

  DeleteData = () => {
    if (this.state.formData.txtNo > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            // alertTitle={"Do you want Delete to Farmer Bill Entry ?"}
            alertTitle={
              " શું તમે ખેડૂત બિલ નં. " +
              this.state.formData.txtNo +
              " વાળા ખેડૂત બિલ એન્ટ્રી ને ડિલીટ કરવા માંગો છો ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteFarmerBill(this.state.formData.txtNo);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteFarmerBill = () => {
    let dataLoadStatus = false;
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteFarmerBill",
        bint_acid: localStorage.getItem("acid"),
        bint_acyear: localStorage.getItem("ACY"),
        // bint_itemsrno,
        bint_inwardno: this.state.formData.txtNo,
        // bol_list: true,
      };
      fetchFarmerBillDetail(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          let dataLoadStatus = true,
            rows = [],
            rowsCount = 0,
            ARD = null;
          if (res.data.msgType === "success") {
            if (
              res.data.farmerbillmaster &&
              res.data.farmerbillmaster.length > 0
            ) {
              rows = res.data.farmerbillmaster;
              rowsCount = rows.length;
            }
          }
          // console.log("rows", rows);

          this.setState(
            {
              ARD,
              rows,
              rowsCount,
              dataLoadStatus,
            },
            () => {
              this.clearInfo();
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in DeleteFarmerBill.", error);
        });
    });
  };

  deletefarmerbillItem = (bint_itemsrno) => {
    this.props.notifyProcessing();
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteFarmerBillItem",
        bint_acid: localStorage.getItem("acid"),
        bint_acyear: localStorage.getItem("ACY"),
        bint_itemsrno,
        bint_inwardno: this.state.formData.txtNo,
        bol_list: true,
      };
      fetchFarmerBillDetail(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          let dataLoadStatus = true,
            rows = [],
            rowsCount = 0,
            ARD = null;
          if (res.data.msgType === "success") {
            if (res.data.FarmerBillItem && res.data.FarmerBillItem.length > 0) {
              if (res.data.FarmerBillItem.length >= 5) {
                rows = res.data.FarmerBillItem;
              } else {
                for (let i = 0; i < 5; i++) {
                  let row = {
                    bint_edititemsrno: i + 1, // Increment `newSrNo` by `i` on each iteration
                    bint_itemsrno: "",
                    int_jansicode: "",
                    vac_jansiname: "",
                    int_comagentcode: "",
                    vac_comagentname: "",
                    dec_theli: "",
                    dec_rate: "",
                    dec_wt: "",
                    dec_uchak: "",
                    dec_amt: "",
                    dec_marketfees: "",
                    dec_commision: "",
                    dec_totalamt: "",
                    vac_remark: "",
                  };

                  rows.push(
                    res.data.FarmerBillItem[i] !== undefined
                      ? res.data.FarmerBillItem[i]
                      : row
                  );
                }
              }

              rowsCount = rows.length;
            }
          }
          // console.log("rows", rows);

          this.setState(
            {
              ARD,
              rows,
              rowsCount,
              dataLoadStatus,
            },
            () => {
              // this.clearInfo();
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteSalesList.", error);
        });
    });
  };
  setCmbItem = () => {
    let columns = this.state.columns;
    columns = columns.map((col) => {
      if (col.id === "vac_jansiname") {
        col.CtrlProps.items = this.state.Item;
      }
      if (col.id === "int_jansicode") {
        col.CtrlProps.items = this.state.Item;
      }
      if (col.id === "vac_comagentname") {
        col.CtrlProps.items = this.state.Comagent;
      }
      if (col.id === "int_comagentcode") {
        col.CtrlProps.items = this.state.Comagent;
      }
      return col;
    });
    // console.log("columns", columns);
    this.setState({ columns });
  };

  onFormLoad = () => {
    // if (this.validate()) {
    let dataLoadStatus = false;
    this.setState(
      { dataLoadStatus, autoResetFormData: false, isInitialLoad: true },
      () => {
        let bint_acyear = 0,
          bint_acid = "",
          bint_inwardno = 0;
        if (this.props.location.state && this.props.location.state != null) {
          this.setState({ isEditMode: true });
          bint_acid = this.props.location.state.bint_acid;
          bint_inwardno = this.props.location.state.bint_inwardno;
          bint_acyear = this.props.location.state.bint_acyear;
          let reqData = {
            Op: "FarmerBillData",
            bint_acyear,
            bint_acid,
            bint_inwardno,
            vac_userid: localStorage.getItem("logInID"),
          };
          fetchFarmerBillDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);

              let Item = [],
                Comagent = [],
                rows = [],
                Village = [],
                rowsPaymentMode = [],
                PaymentData = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                Farmer = [];
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                PaymentData = res.data.PaymentData;
              }
              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                res.data.PaymentData.map((odd) => {
                  let isFound = 0;
                  rowsPaymentMode.map((rod) => {
                    if (rod.vac_ledgername === odd.vac_ledgername) {
                      // rod.vac_value = odd.vac_value;
                      rod.dec_amount = odd.dec_amount;
                      rod.vac_chequeno = odd.vac_chequeno;
                      rod.vac_referenceno = odd.vac_referenceno;
                      rod.dat_transactiondate = odd.dat_transactiondate;
                      rod.vac_remark = odd.vac_remark;
                      rod.vac_groupname = odd.vac_groupname;
                      isFound++;
                    }
                  });
                  if (isFound === 0) {
                    rowsPaymentMode.push({
                      vac_ledgername: odd.vac_ledgername,
                      dec_amount: odd.dec_amount,
                      vac_chequeno: odd.vac_chequeno,
                      vac_referenceno: odd.vac_referenceno,
                      dat_transactiondate: odd.dat_transactiondate,
                      vac_remark: odd.vac_remark,
                      vac_groupname: odd.vac_groupname,
                      // bint_displayorderno: rowsPaymentMode.length + 1,
                    });
                  }
                });
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.ItemList && res.data.ItemList.length > 0) {
                Item = res.data.ItemList;
                if (res.data.ComagentList && res.data.ComagentList.length > 0) {
                  Comagent = res.data.ComagentList;
                }
                if (res.data.FarmerList && res.data.FarmerList.length > 0) {
                  Farmer = res.data.FarmerList;
                }

                if (res.data.VillageList && res.data.VillageList.length > 0) {
                  Village = res.data.VillageList;
                }
                if (
                  res.data.FarmerBillItem &&
                  res.data.FarmerBillItem.length > 0
                ) {
                  if (res.data.FarmerBillItem.length >= 5) {
                    rows = res.data.FarmerBillItem;
                  } else {
                    for (let i = 0; i < 5; i++) {
                      let row = {
                        bint_edititemsrno: i + 1, // Increment `newSrNo` by `i` on each iteration
                        bint_itemsrno: "",
                        int_jansicode: "",
                        vac_jansiname: "",
                        int_comagentcode: "",
                        vac_comagentname: "",
                        dec_theli: "",
                        dec_rate: "",
                        dec_wt: "",
                        dec_uchak: "",
                        dec_amt: "",
                        dec_marketfees: "",
                        dec_commision: "",
                        dec_totalamt: "",
                        vac_remark: "",
                      };

                      // console.log("res.data.FarmerBillItem[i]", res.data.FarmerBillItem[i])
                      // console.log("res.data.FarmerBillItem", res.data.FarmerBillItem)
                      rows.push(
                        res.data.FarmerBillItem[i] !== undefined
                          ? res.data.FarmerBillItem[i]
                          : row
                      );
                    }
                  }
                }
                this.setState(
                  {
                    PaymentData,
                    Farmer,
                    Comagent,
                    Item,
                    Village,
                    rows,
                    rowsPaymentMode,
                    rowsCountPaymentMode,
                    DefaultEntrySettingList,
                    formData: {
                      ...this.state.formData,
                      dtpDate: res.data.FarmerBillList[0]?.dat_inworddate || "",
                      txtNo: res.data.FarmerBillList[0]?.bint_inwardno || "",
                      bint_editinwordno:
                        res.data.FarmerBillList[0]?.bint_inwardno || "",
                      edit_farmerno:
                        res.data.FarmerBillList[0]?.bint_inwardno || "",
                      txtItemTotal:
                        res.data.FarmerBillList[0]?.dec_itemtotal || "",
                      txttruckBhaddu:
                        res.data.FarmerBillList[0]?.dec_truckrate || "",
                      txtBardan:
                        res.data.FarmerBillList[0]?.dec_minusloading || "",
                      txtSutli: res.data.FarmerBillList[0]?.dec_sutli || "",
                      txtTotalAmount:
                        res.data.FarmerBillList[0]?.dec_totaladdamt || "",
                      txtAnay: res.data.FarmerBillList[0]?.dec_anya || "",
                      txtUmero: res.data.FarmerBillList[0]?.dec_add || "",
                      txtBardan1:
                        res.data.FarmerBillList[0]?.dec_addloading || "",
                      txtBaad: res.data.FarmerBillList[0]?.dec_minus || "",
                      txtUpad: res.data.FarmerBillList[0]?.dec_upad || "",
                      txtAnnay: res.data.FarmerBillList[0]?.dec_anya2 || "",
                      txtBaadRakam:
                        res.data.FarmerBillList[0]?.dec_totalminusamt || "",
                      txtTotalRakaam:
                        res.data.FarmerBillList[0]?.dec_totalamount || "",
                      txtvepariNo:
                        res.data.FarmerBillList[0]?.vac_veparibillno || "",
                      txtCity: res.data.FarmerBillList[0]?.vac_village || "",
                      txtkhedutNo:
                        res.data.FarmerBillList[0]?.bint_farmerbillno || "",
                      txtRemark: res.data.FarmerBillList[0]?.vac_remark || "",
                      txtFarmerName:
                        res.data.FarmerBillList[0]?.vac_farmername || "",
                      cmbFatherName:
                        res.data.FarmerBillList[0]?.vac_fathername || "",
                      transactionType:
                        res.data.FarmerBillList[0]?.vac_paymenttype || "",
                    },
                  },
                  () => {
                    if (
                      res.data.FarmerBillList[0]?.vac_paymenttype ===
                        "ચૂકવેલ" &&
                      !this.state.isEditMode &&
                      !this.state.hasOpenedTransactionType
                    ) {
                      this.setState({ hasOpenedTransactionType: false });
                    } else if (
                      res.data.FarmerBillList[0]?.vac_wbc_trantype === "બાકી"
                    ) {
                      this.setState({
                        isEditMode: false,
                        isInitialLoad: false,
                      });
                    }
                    this.setCmbItem();
                  }
                );
              }
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        } else {
          this.loadAllCmb();
          document.getElementById("dtpDate").focus();

          // let reqData = {
          //   Op: "LoadAllCmbFarmerBill",
          //   bint_acid: localStorage.getItem("acid"),
          //   bint_acyear: localStorage.getItem("ACY"),
          //   vac_userid: localStorage.getItem("logInID"),
          //   bint_inwardno: this.state.formData.txtNo,
          // };

          // fetchFarmerBillDetail(reqData)
          //   .then((res) => {
          //     dataLoadStatus = true;
          //     let txtNo = Number(this.state.formData.txtNo) > 0
          //       ? this.state.formData.txtNo
          //       : res.data.nextInwordNo;

          //     let txtkhedutNo = Number(this.state.formData.txtkhedutNo) > 0
          //       ? this.state.formData.txtkhedutNo
          //       : res.data.bint_farmerbillno,

          //       Item = [],
          //       Village = [],
          //       Comagent = [],
          //       Farmer = [];

          //     if (res.data.ItemList && res.data.ItemList.length > 0) {
          //       Item = res.data.ItemList;
          //       if (res.data.ComagentList && res.data.ComagentList.length > 0) {
          //         Comagent = res.data.ComagentList;
          //       }
          //       if (res.data.VillageList && res.data.VillageList.length > 0) {
          //         Village = res.data.VillageList;
          //       }
          //       if (res.data.FarmerList && res.data.FarmerList.length > 0) {
          //         Farmer = res.data.FarmerList;
          //       }
          //       this.setState(
          //         {
          //           formData: {
          //             ...this.state.formData,
          //             txtNo,
          //             txtkhedutNo,
          //           },
          //           Farmer,
          //           Village,
          //           Comagent,
          //           Item,
          //         },
          //         () => {
          //           this.setCmbItem();
          //         }
          //       );
          //       document.getElementById("txtNo").focus();
          //     }
          //   })
          //   .catch((error) => {
          //     console.log("Unknown error occurred in onFormLoad.", error);
          //   });
        }
      }
    );
  };

  clearInfo = () => {
    let edit_incomesrno = "",
      txtItemTotal = "",
      txtTruckRent = "",
      txtBardan = "",
      txtSutli = "",
      txtTotalAmount = "",
      txtAnay = "",
      txtUmero = "",
      txtBardan1 = "",
      txtBaad = "",
      txttruckBhaddu = "",
      txtUpad = "",
      txtAnnay = "",
      txtBaadRakam = "",
      txtTotalRakaam = "",
      txtvepariNo = "",
      txtCity = "",
      txtkhedutNo = "",
      txtFarmerName = "",
      cmbFatherName = "",
      txtRemark = "",
      bint_editinwordno = 0;

    let rows = [];

    // Create 5 rows, each with a unique `newSrNo` incremented by 1
    for (let i = 0; i < 5; i++) {
      let row = {
        bint_edititemsrno: 1 + i, // Increment `newSrNo` by `i` on each iteration
        bint_itemsrno: "",
        int_jansicode: "",
        vac_jansiname: "",
        int_comagentcode: "",
        vac_comagentname: "",
        dec_theli: "",
        dec_rate: "",
        dec_wt: "",
        dec_uchak: "",
        dec_amt: "",
        dec_marketfees: "",
        dec_commision: "",
        dec_totalamt: "",
        vac_remark: "",
      };

      rows.push(row);
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          edit_farmerno: 0,
          txtNo: 0,
          txtkhedutNo,
          edit_incomesrno,
          txtItemTotal,
          txtTruckRent,
          txtBardan,
          txtSutli,
          txtTotalAmount,
          txtAnay,
          txtUmero,
          txtBardan1,
          txtBaad,
          txttruckBhaddu,
          txtUpad,
          txtAnnay,
          txtBaadRakam,
          txtTotalRakaam,
          txtvepariNo,
          txtCity,
          txtkhedutNo,
          txtFarmerName,
          cmbFatherName,
          txtRemark,
          bint_editinwordno,
        },
        rows,
        rowsCount: rows.length,
      },
      () => {
        document.getElementById("txtFarmerName").focus();
        this.loadAllCmb();
      }
      // () => {
      //   document.getElementById("txtFarmerName").focus();
      // }
    );
    // this.props.notifyProcessing();
    // const reqData = {
    //   Op: "LoadAllCmbFarmerBill",
    //   bint_acid: localStorage.getItem("acid"),
    //   bint_acyear: localStorage.getItem("ACY"),
    //   bint_inwardno: 0,
    // };
    // fetchFarmerBillDetail(reqData)
    //   .then((res) => {
    //     this.props.closeUpdateProcessing();
    //     this.setState({
    //       formData: {
    //         ...this.state.formData,
    //         edit_farmerno: res.data.bint_inwardno,
    //         txtNo: res.data.nextInwordNo,
    //         txtkhedutNo: res.data.bint_farmerbillno,
    //         edit_incomesrno,
    //         txtItemTotal,
    //         txtTruckRent,
    //         txtBardan,
    //         txtSutli,
    //         txtTotalAmount,
    //         txtAnay,
    //         txtUmero,
    //         txtBardan1,
    //         txtBaad,
    //         txttruckBhaddu,
    //         txtUpad,
    //         txtAnnay,
    //         txtBaadRakam,
    //         txtTotalRakaam,
    //         txtvepariNo,
    //         txtCity,
    //         txtkhedutNo,
    //         txtFarmerName,
    //         cmbFatherName,
    //         txtRemark,
    //         bint_editinwordno,
    //       },
    //       rows,
    //     });
    //   })
    //   .catch(
    //     (error) => {
    //       console.log("Unknown error occurred in onFormLoad.", error);
    //     },
    //     () => {
    //       document.getElementById("txtNo").focus();
    //     }
    //   );
  };

  loadAllCmb = () => {
    let reqData = {
      Op: "LoadAllCmbFarmerBill",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      vac_userid: localStorage.getItem("logInID"),
      bint_inwardno: this.state.formData.txtNo,
    };

    fetchFarmerBillDetail(reqData)
      .then((res) => {
        this.setState({ isEditMode: false, isInitialLoad: false });
        // dataLoadStatus = true;
        let txtNo =
            Number(this.state.formData.txtNo) === 0
              ? res.data.nextInwordNo
              : this.state.formData.txtNo,
          txtkhedutNo =
            Number(this.state.formData.txtkhedutNo) > 0
              ? this.state.formData.txtkhedutNo
              : res.data.bint_farmerbillno,
          Item = [],
          Village = [],
          Comagent = [],
          rowsPaymentMode = [],
          PaymentData = [],
          DefaultEntrySettingList = [],
          rowsCountPaymentMode = rowsPaymentMode.length,
          transactionType = "",
          Farmer = [];
        console.log("this.state.formData.txtNo", txtNo);
        if (res.data.ItemList && res.data.ItemList.length > 0) {
          Item = res.data.ItemList;
        }
        if (res.data.ComagentList && res.data.ComagentList.length > 0) {
          Comagent = res.data.ComagentList;
        }
        if (
          res.data.DefaultEntrySettingList &&
          res.data.DefaultEntrySettingList.length > 0
        ) {
          DefaultEntrySettingList = res.data.DefaultEntrySettingList;
        }
        if (res.data.PaymentData && res.data.PaymentData.length > 0) {
          PaymentData = res.data.PaymentData;
        }
        if (DefaultEntrySettingList.length > 0) {
          transactionType = DefaultEntrySettingList[0].vac_transacationtype;
        }
        if (res.data.VillageList && res.data.VillageList.length > 0) {
          Village = res.data.VillageList;
        }
        if (res.data.FarmerList && res.data.FarmerList.length > 0) {
          Farmer = res.data.FarmerList;
        }
        if (res.data.LedgerNameList && res.data.LedgerNameList.length > 0) {
          rowsPaymentMode = res.data.LedgerNameList;
          rowsCountPaymentMode = rowsPaymentMode.length;
        }

        this.setState(
          {
            formData: {
              ...this.state.formData,
              txtNo,
              txtkhedutNo,
              transactionType,
            },
            PaymentData,
            DefaultEntrySettingList,
            rowsPaymentMode,
            rowsCountPaymentMode,
            Farmer,
            Village,
            Comagent,
            Item,
          },
          () => {
            console.log("this.state.formData.txtNo", this.state.formData.txtNo);

            this.setCmbItem();
          }
        );
        // document.getElementById("txtFarmerName").focus();
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
  };

  openInvoice = (bint_acid, bint_acyear, dat_inworddate, vac_companyname) => {
    let rows = this.state.rows;
    const filteredRows = rows.filter((row) => {
      return Object.keys(row).some((key) => {
        if (key === "bint_edititemsrno") return false;
        return row[key] !== "" && row[key] !== null && row[key] !== undefined;
      });
    });

    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "VepariBillPrint" },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_acyear", value: bint_acyear },
      { name: "dat_inworddate", value: dat_inworddate },
      { name: "vac_companyname", value: vac_companyname },
      { name: "vepari_data", value: JSON.stringify(filteredRows) },

      // {
      //   name: "SalesInvoiceSelection",
      //   value: JSON.stringify(CheckedInvoiceList),
      // },
      // { name: "PaperType", value: this.state.formData.cmbPaper },
    ];
    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiFarmerURL + "farmerbilldetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "SalesList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  openInvoiceKhedut = (bint_acid, bint_acyear, bint_inwardno) => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "MarketfeesMultipleBillPrint" },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_acyear", value: bint_acyear },
      { name: "bint_inwardnofrom", value: bint_inwardno },
      { name: "bint_inwardnoto", value: bint_inwardno },
      { name: "dat_datefrom", value: "" },
      { name: "dat_dateto", value: "" },
      { name: "GenerateBillType", value: "" },

      // {
      //   name: "SalesInvoiceSelection",
      //   value: JSON.stringify(CheckedInvoiceList),
      // },
      // { name: "PaperType", value: this.state.formData.cmbPaper },
    ];
    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiFarmerURL + "farmerbilldetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "MarketFee",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  openInvoiceKhedut1 = (bint_acid, bint_acyear, bint_inwardno) => {
    this.props.notifyProcessing();
    let reqData = [
      { name: "Op", value: "KhedutMultipleBillPrint" },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_acyear", value: bint_acyear },
      { name: "bint_inwardnofrom", value: bint_inwardno },
      { name: "bint_inwardnoto", value: bint_inwardno },
      { name: "dat_datefrom", value: "" },
      { name: "dat_dateto", value: "" },
      { name: "GenerateBillType", value: "" },
      //   name: "SalesInvoiceSelection",
      //   value: JSON.stringify(CheckedInvoiceList),
      // },
      // { name: "PaperType", value: this.state.formData.cmbPaper },
    ];
    // Create a query string from the request data
    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    // Set the URL of the popup window
    let popupURL = apiFarmerURL + "farmerbilldetail.php?" + queryString;

    // Open the popup window
    window.open(
      popupURL,
      "SalesList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  getPayRemarkLblVisibleStatus = () => {
    return this.state.formData.transactionType == "બાકી" &&
      Number(this.state.formData.txtAdvPayment) > 0 &&
      this.state.formData.chkReceiptGenerated === false
      ? true
      : false;
  };

  getPaymentModeDataStatus = () => {
    let result = false;
    if (
      this.state.formData.transactionType == "ચૂકવેલ" ||
      this.getPayRemarkLblVisibleStatus()
    ) {
      result = true;
    } else {
      this.state.rowsPaymentMode.map((row) => {
        // row.vac_ledgername = ''
        row.dec_amount = "";
        row.vac_chequeno = "";
        row.vac_referenceno = "";
        row.dat_transactiondate = "";
        row.vac_remark = "";
      });
    }
    return result;
    /* return this.state.formData.transactionType == "ચૂકવેલ" ||
      this.getPayRemarkLblVisibleStatus()
      ? true
      : false; */
  };

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {}
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      console.log("DefaultEntrySettingList 2073", DefaultEntrySettingList);

      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "ચૂકવેલ"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "ચૂકવેલ"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
    console.log("DefaultEntrySettingList", DefaultEntrySettingList);
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    // this.togglePaymentModeInfo(); // Set anchor element to the clicked target
  };

  handleClose = () => {
    this.setState({ anchorEl: null }); // Close the menu
  };

  handleSelectTransactionType = () => {
    if (!(this.state.isEditMode && this.state.isInitialLoad)) {
      this.openTransactionType();
      this.getPaymentModeDataStatus();
    }
  };

  openTransactionType = () => {
    let ARD = null;
    const { PaymentData, rowsPaymentMode } = this.state;
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();
    console.log("DefaultEntrySettingList", DefaultEntrySettingList);

    const txtAmount4PaymentModeTable = Number(
      this.state.formData.txtTotalRakaam
    );

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage={
            <PaymentModeTable
              DefaultEntrySettingList={DefaultEntrySettingList}
              PaymentData={PaymentData}
              PaymentLedgerNameList={rowsPaymentMode}
              Edit_SrNo={this.state.formData.edit_purchasesrno}
              setPaymentData={this.setPaymentData}
              txtAmount={txtAmount4PaymentModeTable}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            // this.setState({ rowsPaymentMode });
          }}
        />
      );
      this.setState({ ARD });
      console.log("rowsPaymentMode:", this.state.rowsPaymentMode);
    });
  };
  getPaymentModeInfoAsText = () => {
    const { rowsPaymentMode } = this.state;

    if (rowsPaymentMode.length === 0) {
      // return "No payment mode information available.";
      return " ચુકવણી મોડ વિશે કોઈ માહિતી ઉપલબ્ધ નથી.";
    }

    return rowsPaymentMode
      .map((row, index) => {
        return `Payment Mode ${index + 1}:
        Ledger Name: ${row.vac_ledgername || "N/A"},
        Amount: ${row.dec_amount || "0"},
        Cheque No: ${row.vac_chequeno || "N/A"},
        Reference No: ${row.vac_referenceno || "N/A"},
        Transaction Date: ${row.dat_transactiondate || "N/A"},
        Remark: ${row.vac_remark || "N/A"}`;
      })
      .join("\n");
  };
  refreshPaymentList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  PaymenMode = () => {
    let ARD = null;
    const txtAdvPayment = this.state.formData.txtAdvPayment;
    const cmbCustomer = this.state.formData.cmbCustomer;

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <ReceiptEntry
              refreshPaymentList={this.refreshPaymentList}
              txtAdvPayment={txtAdvPayment}
              cmbCustomer={cmbCustomer}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };
  //#endregion Function

  onAddClickFarmerMaster = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<FarmerMaster />
          defaultOpenDialog={true}
          handleOnClickNo={this.getFarmerMaster}
        />
      );
      this.setState({ ARD });
    });
  };

  getFarmerMaster = () => {};

  onAddClickItem = () => {
    this.removeKeyboardShortCuts();

    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<ItemMaster2 showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getItem();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getItem = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadItem",
      bint_acid: localStorage.getItem("acid"),
      int_jansicode: 0,
    };
    fetchItemDetail(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let Item = res.data.ItemList;
        this.setState(
          {
            Item,
          },
          () => {
            this.setCmbItem();
            document.title = "RA : ખેડૂત બિલ એન્ટ્રી";

            // console.log("Item", Item);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItem.", error);
      });
  };

  onAddClickComAgent = () => {
    this.removeKeyboardShortCuts();
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage=<CommisionAgentMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getComAgent();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getComAgent = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadComagent",
      bint_acid: localStorage.getItem("acid"),
      int_comagentcode: 0,
    };
    fetchComagentDetail(reqData).then((res) => {
      this.props.updateProcessing("success", "Comagent List Loaded");
      let Comagent = res.data.ComagentList;
      this.setState(
        {
          Comagent,
        },
        () => {
          this.setCmbItem();
          document.title = "RA : ખેડૂત બિલ એન્ટ્રી";

          // console.log("Item", Item);
        }
      );
    });
  };

  handleOnNewListClick = () => {
    this.props.navigateTo("FarmerBillList");
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  validateFarmerBillItemCount = () => {
    // this.props.toastErrorMsg("validateSalesItemCount")
    let result = false;
    if (this.state.length <= 0) {
      this.props.toastErrorMsg("કોય એક આઇટમ ઉમેરો.", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  // validateFarmerBillRow = () => {

  //   let result = false;

  //   this.state.rows.map((row) => {
  //     if (row.int_jansicode.length <= 0) {
  //       this.props.toastErrorMsg("Enter Jansi code");
  //     } else if (row.vac_jansiname.length <= 0) {
  //       this.props.toastErrorMsg("Enter Jansi Name");
  //     } else if (row.int_comagentcode.length <= 0) {
  //       this.props.toastErrorMsg("Enter Comagent code");
  //     } else if (row.vac_comagentname.length <= 0) {
  //       this.props.toastErrorMsg("Enter Comagent code");
  //     } else if (row.dec_theli.length <= 0) {
  //       this.props.toastErrorMsg("Enter Theli");
  //     } else if (row.dec_rate.length <= 0) {
  //       this.props.toastErrorMsg("Enter Rate");
  //     } else if (row.dec_wt.length <= 0 && row.dec_uchak.length <= 0) {
  //       this.props.toastErrorMsg("વજન અથવા ઉચ્ચક ઉમેરો");
  //     } else if (row.dec_wt.length <= 0 && row.dec_uchak.length <= 0) {
  //       this.props.toastErrorMsg("ઉચ્ચક ઉમેરો");
  //     } else {
  //       result = false;
  //     }
  //     return result;

  //   });

  // };

  validateFarmerbill = () => {
    // console.log('rows', this.state.rows);
    let result = false;
    if (this.state.formData.txtNo == 0) {
      this.props.toastErrorMsg("ઈનવર્ડ નં. ઉમેરો.", "txtNo");
      // } else if (this.state.formData.txtkhedutNo.length <= 0) {
      //   this.props.toastErrorMsg("Enter Khedut No", "txtkhedutNo");
      // } else if (this.state.formData.txtvepariNo.length <= 0) {
      //   this.props.toastErrorMsg("Enter Vepari No", "txtvepariNo");
    } else if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("તારીખ ઉમેરો", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (this.state.formData.txtFarmerName.length <= 0) {
      this.props.toastErrorMsg("ખેડૂતનું નામ ઉમેરો.", "txtFarmerName");
    } else if (this.state.formData.cmbFatherName.length <= 0) {
      this.props.toastErrorMsg("પિતાનું નામ ઉમેરો.", "cmbFatherName");
    } else if (this.state.formData.txtCity.length <= 0) {
      this.props.toastErrorMsg("ગામ ઉમેરો.", "txtCity");
    } else if (this.state.rows.length <= 0) {
      this.props.toastErrorMsg("એક એન્ટ્રી ઉમેરો.");
    } else {
      result = true;
    }
    return result;
  };
  validateFarmerBillRow = () => {
    const inputRow = [];
    let oneDetaildAdd = false;

    // First check if at least one row has some data
    const hasAnyData = this.state.rows.some(
      (row) =>
        row.int_jansicode ||
        row.vac_jansiname ||
        row.int_comagentcode ||
        row.vac_comagentname ||
        row.dec_theli ||
        row.dec_rate ||
        row.dec_wt ||
        row.dec_uchak
    );

    if (!hasAnyData) {
      this.props.toastErrorMsg(`At least enter one record`);
      return false;
    }

    // Now validate each row one error at a time
    for (let i = 0; i < this.state.rows.length; i++) {
      const row = this.state.rows[i];

      // Skip completely blank rows
      if (
        !row.int_jansicode &&
        !row.vac_jansiname &&
        !row.int_comagentcode &&
        !row.vac_comagentname &&
        !row.dec_theli &&
        !row.dec_rate &&
        !row.dec_wt &&
        !row.dec_uchak
      ) {
        continue;
      }

      oneDetaildAdd = true;

      // Check each condition in order and return on first failure
      if (!row.int_jansicode || row.int_jansicode.length <= 0) {
        this.props.toastErrorMsg(`Row ${i + 1}: જણસી કોડ ઉમેરો.`);
        return false;
      }

      if (!row.vac_jansiname || row.vac_jansiname.length <= 0) {
        this.props.toastErrorMsg(`Row ${i + 1}: જણસી નામ ઉમેરો.`);
        return false;
      }

      if (
        isValidItem(this.state.Item, "vac_jansiname", row.vac_jansiname) ==
        false
      ) {
        this.props.toastErrorMsg(`Row ${i + 1}: જણસી નામ સાચું પસંદ કરો`);
        return false;
      }

      if (!row.int_comagentcode || row.int_comagentcode.length <= 0) {
        this.props.toastErrorMsg(`Row ${i + 1}: લેનાર વેપારી કોડ ઉમેરો.`);
        return false;
      }

      if (!row.vac_comagentname || row.vac_comagentname.length <= 0) {
        this.props.toastErrorMsg(`Row ${i + 1}: લેનાર વેપારી નામ ઉમેરો.`);
        return false;
      }

      if (
        isValidItem(
          this.state.Comagent,
          "vac_comagentname",
          row.vac_comagentname
        ) == false
      ) {
        this.props.toastErrorMsg("લેનાર વેપારી સાચું પસંદ કરો");
        return false;
      }

      if (!row.dec_theli || row.dec_theli.length <= 0) {
        this.props.toastErrorMsg(`Row ${i + 1}: થેલી ઉમેરો.`);
        return false;
      }

      if (!row.dec_rate || row.dec_rate.length <= 0) {
        this.props.toastErrorMsg(`Row ${i + 1}: ભાવ ઉમેરો.`);
        return false;
      }

      if (
        (!row.dec_wt || row.dec_wt.length <= 0) &&
        (!row.dec_uchak || row.dec_uchak.length <= 0)
      ) {
        this.props.toastErrorMsg(`Row ${i + 1}: વજન અથવા ઉચ્ચક ઉમેરો.`);
        return false;
      }

      // If we get here, the row is valid
      inputRow.push(row);
    }

    // If we get here, all rows are valid
    this.setState({ inputRow });
    return true;
  };

  saveFarmerBill = (
    vepariBillPrint = false,
    marketfeesBillPrint = false,
    khedutBillPrint = false
  ) => {
    this.trimFormData(() => {
      // console.log("Validating Farmer Bill...");
      let isValidFarmerBill = this.validateFarmerbill();
      // console.log("Validating Item Count...");
      // let isValidItemCount = this.validateFarmerBillItemCount();
      // console.log("validateFarmerBillItemCount:", isValidItemCount);

      // console.log("Validating Rows...");
      // let isValidRows = this.validateFarmerBillRow();
      // console.log("validateFarmerBillRow:", isValidRows);

      // if (isValidFarmerBill && isValidItemCount && isValidRows) {
      if (isValidFarmerBill) {
        let isValidItemCount = this.validateFarmerBillItemCount();
        let isValidRows = this.validateFarmerBillRow();
        if (isValidItemCount && isValidRows) {
          console.log("this.state.rows", this.state.rows);
          let dataLoadStatus = false;
          this.props.notifyProcessing();
          this.setState({ dataLoadStatus }, () => {
            const reqData = {
              Op: "SaveFarmerBill",
              bint_acid: localStorage.getItem("acid"),
              bint_acyear: localStorage.getItem("ACY"),
              bint_inwardno: this.state.formData.txtNo,
              bint_itemsrno: 0,
              bint_editinwordno: this.state.formData.bint_editinwordno,
              bint_farmerbillno: this.state.formData.txtkhedutNo,
              vac_veparibillno: this.state.formData.txtvepariNo,
              dat_inworddate: this.state.formData.dtpDate,
              vac_farmername: this.state.formData.txtFarmerName,
              vac_fathername: this.state.formData.cmbFatherName,
              vac_village: this.state.formData.txtCity,
              dec_itemtotal: this.state.formData.txtItemTotal,
              dec_minus: this.state.formData.txtBaad,
              dec_truckrate: this.state.formData.txttruckBhaddu,
              dec_minusloading: this.state.formData.txtBardan,
              dec_sutli: this.state.formData.txtSutli,
              dec_upad: this.state.formData.txtUpad,
              dec_anya: this.state.formData.txtAnay,
              dec_totalminusamt: this.state.formData.txtBaadRakam,
              dec_add: this.state.formData.txtUmero,
              dec_addloading: this.state.formData.txtBardan1,
              dec_totaladdamt: this.state.formData.txtTotalAmount,
              dec_totalamount: this.state.formData.txtTotalRakaam,
              dec_anya2: this.state.formData.txtAnnay,
              vac_transactiontype: this.state.formData.transactionType,
              vac_paymenttype: this.state.formData.transactionType,
              vac_remark: this.state.formData.txtRemark,
              FarmerBillItem: this.state.inputRow,
              PaymentData: this.getPaymentModeDataStatus()
                ? this.state.rowsPaymentMode
                : [],
            };
            fetchFarmerBillDetail(reqData)
              .then((res) => {
                this.props.updateProcessing(res.data.msgType, res.data.message);
                if (res.data.msgType === "success") {
                  dataLoadStatus = true;

                  let rows = [];
                  if (
                    res.data.FarmerBillItemList &&
                    res.data.FarmerBillItemList.length > 0
                  ) {
                    if (res.data.FarmerBillItemList.length >= 5) {
                      rows = res.data.FarmerBillItemList;
                    } else {
                      for (let i = 0; i < 5; i++) {
                        let row = {
                          bint_edititemsrno: i + 1, // Increment `newSrNo` by `i` on each iteration
                          bint_itemsrno: "",
                          int_jansicode: "",
                          vac_jansiname: "",
                          int_comagentcode: "",
                          vac_comagentname: "",
                          dec_theli: "",
                          dec_rate: "",
                          dec_wt: "",
                          dec_uchak: "",
                          dec_amt: "",
                          dec_marketfees: "",
                          dec_commision: "",
                          dec_totalamt: "",
                          vac_remark: "",
                        };
                        rows.push(
                          res.data.FarmerBillItemList[i] !== undefined
                            ? res.data.FarmerBillItemList[i]
                            : row
                        );
                      }
                    }
                  }

                  this.setState({
                    dataLoadStatus,
                    rows,
                    formData: {
                      ...this.state.formData,
                      bint_editinwordno: res.data.bint_editinwordno,
                      txtkhedutNo: res.data.bint_farmerbillno,
                    },
                  });
                  if (vepariBillPrint === true) {
                    this.openInvoice(
                      localStorage.getItem("acid"),
                      localStorage.getItem("ACY"),
                      this.state.formData.dtpDate,
                      localStorage.getItem("CompanyName")
                    );
                  } else if (marketfeesBillPrint === true) {
                    this.openInvoiceKhedut(
                      localStorage.getItem("acid"),
                      localStorage.getItem("ACY"),
                      this.state.formData.txtNo
                    );
                  } else if (khedutBillPrint === true) {
                    this.openInvoiceKhedut1(
                      localStorage.getItem("acid"),
                      localStorage.getItem("ACY"),
                      this.state.formData.txtNo
                    );
                  } else {
                    this.clearInfo();
                  }
                  // document.getElementById("txtFarmerName").focus();
                }
              })
              .catch((error) => {
                console.log(
                  "Unknown error occurred in Save Farmerbill.",
                  error
                );
              });
          });
        }
      }
    });
  };

  // removeBlankRows = (rows) =>{

  // }

  render() {
    //   Number(this.state.formData.txtItemTotal) +
    //   Number(this.state.txtTruckRent) +
    //   Number(this.state.txtBardan) +
    //   Number(this.state.txtSutli) +
    //   Number(this.state.txtUpad) +

    //   Number(this.state.totalAfterTaxAmt);
    // txtTotalAmount = txtTotalAmount.toFixed(2);
    // // const totalAmount = this.calculateTotalAmount();
    // this.setJansiDetail();

    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>ખેડૂત બિલ એન્ટ્રી</b>
          </label>
        </Grid> */}

        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={1}
          marginLeft={0}
        >
          {" "}
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            spacing={2}
            marginTop={0}
            marginLeft={0}
          >
            <Grid item>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                spacing={2}
                marginTop={0}
              >
                {/* <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={2}
                  marginTop={0}
                ></Grid>     */}
                <Grid item>
                  <CtTxt
                    id="txtNo"
                    label=" ઈનવર્ડ નં.*"
                    value={this.state.formData.txtNo}
                    handleOnChange={this.handleOnChange}
                    width="140"
                    maxLength={10}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="dtpDate"
                    disabled={true}
                    // disabled={
                    //   Number(this.state.formData.edit_farmerno) > 0
                    //     ? true
                    //     : false
                    // }
                  />
                </Grid>
                <Grid item>
                  <CtTxt
                    id="txtkhedutNo"
                    label=" ખેડૂત બિલ નં."
                    value={this.state.formData.txtkhedutNo}
                    handleOnChange={this.handleOnChange}
                    width="140"
                    maxLength={10}
                    onKeyDown={this.props.onKeyDown}
                    // nextCtrlID="dtpDate"
                    disabled={true}
                  />
                </Grid>

                {/* <Grid item>
                  <CtTxt
                    id="txtvepariNo"
                    label=" વેપારી બિલ નં."
                    value={this.state.formData.txtvepariNo}
                    handleOnChange={this.handleOnChange}
                    width="150"
                    maxLength={10}
                    onKeyDown={this.props.onKeyDown}
                    // nextCtrlID="dtpDate"
                    disabled={true}
                  />
                </Grid> */}
                <Grid item>
                  <CtDtp
                    id="dtpDate"
                    label="ઈનવર્ડ તારીખ*"
                    width="150"
                    maxLength={10}
                    handleOnChange={this.handleOnChange}
                    defaultValue={this.state.formData.dtpDate}
                    value={this.state.formData.dtpDate}
                    onKeyDown={this.props.onKeyDown}
                    accountYear={localStorage.getItem("ACY")}
                    nextCtrlID="txtFarmerName"
                  />
                </Grid>

                {/* Farmer Name */}
                {/* <Grid item >
          <CtCmbEditable
            id="txtFarmerName"
            label="Farmer Name*"
            items={this.state.StateList}
            value={this.state.formData.txtFarmerName}
            handleOnChange={this.handleOnChange}
            width={170}
            maxLength={100}
            onKeyDown={this.props.onKeyDown}
            nextCtrlID="cmbUnit"
          /> */}
                {/* </Grid> */}
                {/* </Grid>

            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            > */}
                {/* Farmer Name */}
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  spacing={2}
                  marginTop={1}
                ></Grid>
                <Grid item>
                  <CtCmbEditable
                    id="txtFarmerName"
                    label=" ખેડૂતનું નામ*"
                    items={this.state.Farmer}
                    value={this.state.formData.txtFarmerName}
                    handleOnChange={this.handleOnChange}
                    width={225}
                    maxLength={100}
                    colID="vac_farmername"
                    // bolVisibleOnAddClickIcon={
                    //   this.props.userPrivilege.Customer == "A" ? true : false
                    // }
                    // onAddClick={this.onAddClickFarmerMaster}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="cmbFatherName"
                  />
                </Grid>
                <Grid item>
                  <CtCmbEditable
                    id="cmbFatherName"
                    label="પિતાનું નામ*"
                    value={this.state.formData.cmbFatherName}
                    handleOnChange={this.handleOnChange}
                    items={this.state.Farmer}
                    width={225}
                    maxLength={100}
                    colID="vac_farmername"
                    bolVisibleOnAddClickIcon={
                      this.props.userPrivilege.Customer == "A" ? true : false
                    }
                    onAddClick={this.onAddClickDriver}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="txtCity"
                  />
                </Grid>

                <Grid item>
                  <CtCmbEditable
                    id="txtCity"
                    label="ગામ*"
                    items={this.state.Village}
                    value={this.state.formData.txtCity}
                    handleOnChange={this.handleOnChange}
                    width="165"
                    maxLength={100}
                    colID="vac_village"
                    onKeyDown={this.props.onKeyDown}
                    // nextCtrlID="txtRemark"
                    nextCtrlID="int_jansicode#0#3"
                  />
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  spacing={2}
                  marginTop={1}
                ></Grid>
                <Grid item>
                  <CtMultiLineText
                    id="txtRemark"
                    label="રીમાર્ક"
                    value={this.state.formData.txtRemark}
                    handleOnChange={this.handleOnChange}
                    width={647}
                    maxLength={1000}
                  />
                </Grid>{" "}
              </Grid>{" "}
            </Grid>
          </Grid>
          {/* <Grid
            container
            direction="row"
            spacing={2}
            justifyContent="flex-start"
            marginTop={0}
            marginLeft={0}
          >
            <Grid item>
              <CtBtn
                variant="contained"
                color="primary"
                onClick={() => this.saveFarmerBill(false, false, false)}
                label={"save"}
              />
            </Grid>

            <Grid item>
              <CtBtn
                variant="contained"
                color="primary"
                onClick={() => this.saveFarmerBill(false, false, true)}
                label={"ખેડુત બિલ પ્રિન્ટ"}
                iconName={"print"}
              />
            </Grid>

            <Grid item>
              <CtBtn
                variant="outlined"
                color="primary"
                onClick={() => this.saveFarmerBill(true, false, false)}
                label="વેપારી બિલ પ્રિન્ટ"
                iconName={"print"}
              />
            </Grid>

            <Grid item>
              <CtBtn
                variant="outlined"
                color="primary"
                onClick={() => this.saveFarmerBill(false, true, false)}
                label="માર્કેટ ફી બિલ પ્રિન્ટ"
                iconName={"print"}
              />
            </Grid>

            <Grid item>
              <CtBtn
                variant="outlined"
                color="secondary"
                onClick={() => {
                  this.clearInfo();
                }}
                label="New"
              />
            </Grid>

            <Grid item>
              <CtBtn
                variant="outlined"
                color="error"
                disabled={
                  Number(this.state.formData.edit_farmerno) > 0 ? false : true
                }
                onClick={() => {
                  this.DeleteData(this.state.formData.txtNo);
                  document.getElementById("txtFarmerName").focus();
                }}
                label="Delete"
              />
            </Grid>

            <Grid item>
              <CtBtn
                iconName={"List"}
                variant="outlined"
                color="primary"
                onClick={this.handleOnNewListClick}
                label="લીસ્ટ"
              />
            </Grid>
          </Grid> */}
          <Grid
            container
            direction="row"
            spacing={2}
            justifyContent="flex-start"
            marginTop={0}
          >
            <Grid item marginLeft={24}>
              <Button variant="outlined" onClick={this.onAddClickItem}>
                જણસી માસ્ટર +
                {/* id="txtjanasiame"
      items={this.state.StateList}
      value={this.state.formData.txtjanasiame}
      bolVisibleOnAddClickIcon={
      this.props.userPrivilege.Customer == "A" ? true : false
    }
    onAddClick={this.onAddClickItem} */}
              </Button>
            </Grid>

            <Grid item marginLeft={44}>
              <Button variant="outlined" onClick={this.onAddClickComAgent}>
                કમિશન એજન્ટ માસ્ટર +{" "}
                {/* id="txtlenarname"
      items={this.state.StateList}
      value={this.state.formData.txtlenarname}
      bolVisibleOnAddClickIcon={
      this.props.userPrivilege.Customer == "A" ? true : false
    }
    onAddClick={this.onAddClickComAgent} */}
              </Button>
              {/* લેનાર વેપારી કોડ. */}
            </Grid>
          </Grid>
        </Grid>

        <Grid item marginLeft={3}>
          {this.state.formData.cmbLedgerGroup === "Customer" ||
          this.state.formData.cmbLedgerGroup === "Supplier" ? (
            <InvoiceListTable
              columns={this.state.columnsTrip}
              rows={this.state.rowstrip}
              btnpaid={"SET TRIP PAID"}
              btnunpaid={"SET TRIP UNPAID"}
              Edit_SrNo={this.state.formData.edit_incomesrno}
              txtAmount={this.state.formData.txtAmount}
              PendingInvoiceList={this.state.PendingInvoiceList}
              setPaymentDataofReceipt={this.setPaymentDataofReceipt}
              EnableReceiptAmt={this.EnableReceiptAmt}
              disableReceiptAmt={this.state.disableReceiptAmt}
              InvoiceData={this.state.InvoiceDataRemoveDuplicateInvoiceNo}
              // setReceiptAmt={this.setReceiptAmt}
            />
          ) : (
            ""
          )}
        </Grid>
        {/* <PaymentModeTable
                      DefaultEntrySettingList={this.state.defaultSetting}
                      PaymentData={this.state.PaymentData}
                      PaymentLedgerNameList={this.state.rows}
                      Edit_SrNo={this.state.formData.edit_incomesrno}
                      setPaymentData={this.setPaymentData}
                      txtAmount={this.state.formData.txtAmount}
            /> */}

        <br />

        <Grid item>
          <Slide in={true} direction="left">
            <div
              style={{
                position: "fixed",
                top: "70px",
                right: "1px",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "8px",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Tooltip
                title={this.state.expanded ? "Hide Actions" : "Show Actions"}
                arrow
              >
                <Button onClick={this.handleToggle}>
                  {this.state.expanded ? <ArrowForwardIos /> : <ArrowBackIos />}
                </Button>
              </Tooltip>

              <Collapse in={!this.state.expanded} orientation="horizontal">
                <Box sx={{ display: "flex", gap: 1, ml: 1 }}>
                  <Tooltip arrow title="લીસ્ટ">
                    <IconButton
                      onClick={() => {
                        this.handleOnNewListClick();
                      }}
                    >
                      <ViewList />
                    </IconButton>
                  </Tooltip>

                  <Tooltip arrow title="Save">
                    <IconButton
                      onClick={() => {
                        this.trimFormData(() => {
                          this.saveFarmerBill(false, false, false);
                        });
                      }}
                    >
                      <Save sx={{ color: "#3487d7" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow title="Print Options">
                    <IconButton onClick={this.handlePrintMenuOpen}>
                      <Print sx={{ color: "#3487d7" }} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip arrow title="New">
                    <IconButton onClick={this.clearInfo}>
                      <AddBox />
                    </IconButton>
                  </Tooltip>

                  {this.props.userPrivilege.ખેડૂતબિલ === "M" && (
                    <Tooltip arrow title="Delete">
                      <IconButton
                        onClick={() => {
                          this.DeleteData(this.state.formData.txtNo);
                          document.getElementById("txtFarmerName").focus();
                        }}
                        disabled={
                          Number(this.state.formData.edit_farmerno) > 0
                            ? false
                            : true
                        }
                      >
                        <Delete sx={{ color: "#fe6969" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              </Collapse>

              <Collapse in={this.state.expanded} orientation="horizontal">
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "center",
                    marginLeft: 1,
                  }}
                >
                  <Grid item>
                    <CtBtn
                      iconName={"List"}
                      variant="outlined"
                      color="primary"
                      onClick={this.handleOnNewListClick}
                      label="લીસ્ટ"
                    />
                  </Grid>
                  <Grid item>
                    <CtBtn
                      variant="contained"
                      color="primary"
                      onClick={() => this.saveFarmerBill(false, false, false)}
                      label={"save"}
                    />
                  </Grid>

                  {/* <Grid item>
                    <CtBtn
                      variant="contained"
                      color="primary"
                      onClick={() => this.saveFarmerBill(false, false, true)}
                      label={"ખેડુત બિલ પ્રિન્ટ"}
                      iconName={"print"}
                    />
                  </Grid>

                  <Grid item>
                    <CtBtn
                      variant="outlined"
                      color="primary"
                      onClick={() => this.saveFarmerBill(true, false, false)}
                      label="વેપારી બિલ પ્રિન્ટ"
                      iconName={"print"}
                    />
                  </Grid>

                  <Grid item>
                    <CtBtn
                      variant="outlined"
                      color="primary"
                      onClick={() => this.saveFarmerBill(false, true, false)}
                      label="માર્કેટ ફી બિલ પ્રિન્ટ"
                      iconName={"print"}
                    />
                  </Grid> */}

                  <Grid item>
                    <CtBtn
                      variant="contained"
                      color="primary"
                      onClick={this.handlePrintMenuOpen}
                      label="Print Options"
                      iconName="print"
                    />
                  </Grid>

                  <Grid item>
                    <CtBtn
                      variant="outlined"
                      onClick={() => {
                        this.clearInfo();
                      }}
                      label="New"
                    />
                  </Grid>

                  <Grid item>
                    <CtBtn
                      variant="outlined"
                      color="error"
                      disabled={
                        Number(this.state.formData.edit_farmerno) > 0
                          ? false
                          : true
                      }
                      onClick={() => {
                        this.DeleteData(this.state.formData.txtNo);
                        document.getElementById("txtFarmerName").focus();
                      }}
                      label="Delete"
                    />
                  </Grid>
                </Box>
              </Collapse>
            </div>
          </Slide>
        </Grid>

        <Menu
          anchorEl={this.state.printMenuAnchor}
          open={Boolean(this.state.printMenuAnchor)}
          onClose={this.handlePrintMenuClose}
          style={{ marginTop: "10px" }}
          sx={{
            mt: 1,
            "& .MuiPaper-root": {
              borderRadius: "10px",
              boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.1)",
              // minWidth: 200,
            },
          }}
        >
          <MenuItem
            onClick={() => {
              this.saveFarmerBill(false, false, true);
              this.handlePrintMenuClose();
            }}
            sx={{
              fontSize: "15px",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#f0f4ff",
                color: "#3487d7",
              },
            }}
          >
            ખેડૂત બિલ પ્રિન્ટ
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.saveFarmerBill(true, false, false);
              this.handlePrintMenuClose();
            }}
            sx={{
              fontSize: "15px",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#f0f4ff",
                color: "#3487d7",
              },
            }}
          >
            વેપારી બિલ પ્રિન્ટ
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.saveFarmerBill(false, true, false);
              this.handlePrintMenuClose();
            }}
            sx={{
              fontSize: "15px",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#f0f4ff",
                color: "#3487d7",
              },
            }}
          >
            માર્કેટ ફી બિલ પ્રિન્ટ
          </MenuItem>
        </Menu>

        <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={this.state.rows}
          rowsCount={this.state.rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          // newBtnClick={this.onAddClickDriver}
          // newBtnClick={this.handleOnNewEntryClick}
          //  actionColSize={90}
          // density={"compact"}
          //  newBtnName={"New Trip Item"}
          // handleOnSearchChange={this.handleOnSearchChange}
          // searchColumns={this.state.searchColumns}
          // searchData={this.state.searchData}
          // provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
          handleOnRowDataChange={this.handleOnRowDataChange}
        />
        <Grid
          direction="row"
          justifyContent="flex-start"
          // alignItems="center"
          spacing={2}
          marginTop={0}
          container
          marginLeft={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtItemTotal"
              label="આઇટમ ટોટલ"
              value={this.state.rows
                .reduce(
                  (total, row) => total + (parseFloat(row.dec_totalamt) || 0),
                  0
                )
                .toFixed(2)}
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtTruckRent"
              disabled={true}
            />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            spacing={2}
            marginTop={1}
          >
            {" "}
          </Grid>
          <Grid item>
            <Typography
              variant="body1"
              fontWeight="bold"
              style={{ marginTop: "23px" }}
            >
              બાદ
            </Typography>
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txttruckBhaddu"
              label="ટ્રક ભાડુ"
              value={this.state.formData.txttruckBhaddu}
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              // nextCtrlID="txtSutli"
            />
          </Grid>

          <Grid item>
            <CtTxtAmt
              id="txtBardan"
              label="બારદાન"
              value={this.state.formData.txtBardan}
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtSutli"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtSutli"
              label="સુતળી"
              value={this.state.formData.txtSutli}
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtUpad"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtUpad"
              label="ઉપાડ"
              value={this.state.formData.txtUpad}
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtAnay"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtAnay"
              label="અન્ય"
              value={this.state.formData.txtAnay}
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtBardan1"
            />
          </Grid>

          <Grid item>
            <CtTxtAmt
              id="txtBaadRakam"
              label="કુલ બાદ રકમ"
              value={this.state.formData.txtBaadRakam} // Use the calculated total amount here
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              // nextCtrlID="txtTotalAmount"
              disabled={true}
            />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            spacing={2}
            marginTop={1}
          ></Grid>

          <Grid item>
            <Typography
              variant="body1"
              fontWeight="bold"
              style={{ marginTop: "23px" }}
            >
              ઉમેરો
            </Typography>
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtBardan1"
              label="બારદાન"
              handleOnChange={this.handleOnChange}
              value={this.state.formData.txtBardan1} // Use the calculated total amount here
              width="150"
              maxLength={10}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtAnnay"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtAnnay"
              label="અન્ય"
              value={this.state.formData.txtAnnay} // Use the calculated total amount here
              handleOnChange={this.handleOnChange}
              // value={totalAmount} // Use the calculated total amount here
              width="150"
              onKeyDown={this.props.onKeyDown}
              maxLength={10}
              nextCtrlID="transactionType"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTotalAmount"
              label="કુલ ઉમેરો રકમ"
              handleOnChange={this.handleOnChange}
              value={this.state.formData.txtTotalAmount} // Use the calculated total amount here
              width="150"
              maxLength={10}
              disabled={true}
            />
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            spacing={2}
            marginTop={1}
          ></Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTotalRakaam"
              label="ટોટલ રકમ"
              value={this.state.formData.txtTotalRakaam} // Use the calculated total amount here
              handleOnChange={this.handleOnChange}
              width="150"
              maxLength={10}
              disabled={true}
            />
          </Grid>
        </Grid>
        <FormControl fullWidth>
          <Box
            display="flex"
            justifyContent="space-between"
            marginLeft={2}
            marginTop={0}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              marginTop={2}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "16px",
                }}
              >
                <CtCmb
                  id="transactionType"
                  label="વ્યવહારનો પ્રકાર*"
                  items={[
                    { label: "ચૂકવેલ", value: "ચૂકવેલ" },
                    { label: "બાકી", value: "બાકી" },
                  ]}
                  colID="value"
                  value={this.state.formData.transactionType}
                  handleOnChange={this.handleOnChange}
                  width={200}
                  variant="standard"
                />

                {this.state.formData.transactionType === "ચૂકવેલ" && (
                  <div style={{ marginLeft: "8px" }}>
                    <img
                      src={PaymentModeIcon}
                      alt="Payment Mode"
                      style={{
                        marginTop: "14px",
                        cursor: "pointer",
                        width: "34px",
                        height: "34px",
                      }}
                      onClick={this.openTransactionType}
                    />
                  </div>
                )}
              </div>
              <Box>
                {this.state.rowsPaymentMode.map((row, index) => {
                  if (
                    this.state.formData.transactionType !== "ચૂકવેલ" ||
                    !row.dec_amount
                  ) {
                    return null;
                  }

                  const backgroundprocess = row.vac_backgroundprocess;
                  if (!["Cash", "Cheque", "Bank"].includes(backgroundprocess)) {
                    return null;
                  }

                  return (
                    <Box key={`payment-${index}`}>
                      <h4 style={{ margin: 5 }}>
                        Payment Mode: {row.vac_ledgername}
                      </h4>
                      <h4 style={{ margin: 5 }}>Amount: {row.dec_amount}</h4>
                      <h4 style={{ margin: 5 }}>
                        Cheque No: {row.vac_chequeno}
                      </h4>
                      <h4 style={{ margin: 5 }}>
                        Reference No: {row.vac_referenceno}
                      </h4>
                      <h4 style={{ margin: 5 }}>
                        Transaction Date:{" "}
                        {row.dat_transactiondate &&
                        row.dat_transactiondate !== "0000-00-00"
                          ? moment(row.dat_transactiondate).format("DD-MM-YYYY")
                          : ""}
                      </h4>
                      <h4 style={{ margin: 5 }}>Remark: {row.vac_remark}</h4>
                      <hr />
                    </Box>
                  );
                })}
              </Box>
            </Box>{" "}
            <Box flex={2} marginX={20}>
              <Grid item sm={12} lg={6}>
                <Grid
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                  marginTop={0}
                >
                  <Grid item>
                    {this.state.formData.cmbCustomer.length > 0 ? (
                      <TableList
                        columns={this.state.columnsOtherDetail}
                        counter={this.state.counter}
                        rows={this.state.rowsOtherDetail1.filter(
                          (row) => row.vac_calculation !== ""
                        )}
                        rowsCount={this.state.rowsCountOtherDetail1}
                        rowsPerPage={this.state.rowsPerPageOtherDetail1}
                        handleChangeRowsPerPage={
                          this.handleChangeRowsPerPageOtherDetail1
                        }
                        // handleOnRowDataChange={this.handleOnRowDataChange}
                      />
                    ) : (
                      ""
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            {/* <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
              position="sticky"
              top={0}
            >
              {/* <h4 style={{ margin: 5 }}>
                Total Basic Amount: {this.state.totalBeforeTaxAmt}
              </h4> */}
            {/*}
              <h4 style={{ margin: 5 }}>
                Total Discount: {this.state.formData.txtDiscount}
              </h4>
              <h4 style={{ margin: 5 }}>
                Total Taxable Amount: {this.state.formData.txtTaxable}
              </h4>
              <h4 style={{ margin: 5 }}>
                Before Tax Amount: {this.state.totalBeforeTaxAmt}
              </h4>

              <h4 style={{ margin: 5 }}>Total CGST: {CGST}</h4>
              <h4 style={{ margin: 5 }}>Total SGST: {SGST}</h4>
              <h4 style={{ margin: 5 }}>Total IGST: {SGST}</h4>

              <h4 style={{ margin: 5 }}>
                After Tax Amount: {this.state.totalAfterTaxAmt}
              </h4>

              <h4 style={{ margin: 5 }}>RoundOff: {txtRoundOff}</h4>

              <h4 style={{ margin: 5 }}>Grand Total: {txtGrandTotal}</h4>
              <CtTxt
                id="txtTDSAmount"
                label="TDS Amount"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtTDSAmount}
                width={110}
                maxLength={10}
                textAlign="right"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID="txtAdvPayment"
              />
              <Box display="flex" justifyContent="flex-end" gap={3}>
                {this.state.formData.cmbCustomer &&
                  this.state.formData.txtAdvPayment > 0 && (
                    <CtBtn
                      label="Generated Receipt"
                      onClick={this.PaymenMode}
                    />
                  )}

                <CtTxtAmt
                  id="txtAdvPayment"
                  label="Adv Payment"
                  // disabled={true}
                  value={this.state.formData.txtAdvPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  textAlign="right"
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
                {/* <h4 style={{ margin: 5 }}>
                  Adv Payment:
                  {this.state.formData.txtAdvPayment}
                </h4> */}
            {/*}
              </Box>
              <h4 style={{ margin: 5 }}>Net Payment: {NetPayment}</h4>
            </Box> */}
          </Box>
        </FormControl>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(FarmerBillEntry))));
